import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

import { SessionVaultService } from '@services/session-vault/session-vault.service';
import { AuthService } from '../services/auth.service';

/**
 * Protects every route except the login page.
 *
 * The decision is AuthService.canEnterApp — the predicate NoAuthGuard, RootHistorySetter and the
 * login page share. With one rule for all of them a navigation one side starts is never refused by
 * the other, which used to end in a ping-pong between /login and the target route (#26615).
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  path: ActivatedRouteSnapshot[];
  route: ActivatedRouteSnapshot;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _sessionVault: SessionVaultService
  ) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.check();
  }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.check();
  }

  private async check(): Promise<boolean> {
    await this._authService.init;

    if (this._authService.canEnterApp) {
      return true;
    }

    await this._router.navigate(['/login']);

    return false;
  }
}
